import * as queryString from 'query-string'
import { removeUndefined } from 'firebaseFunctions/utilities/removeUndefined'
import { GenericObject } from 'types/GenericObject'

export const createCleanQueryString = ({ query }: { query: GenericObject<any> }) => {
  const removedUndefined = removeUndefined(query)

  return queryString.stringify(removedUndefined)
}
